
<div class="container">
  @if (!isReadonly) {
    <input 
      #searchBox 
      type="text" 
      class="search-input" 
      placeholder="Search for an address...">
  }

  <div class="map-container">
    <google-map
      height="100%"
      width="100%"
      [center]="center"
      [zoom]="zoom"
      [options]="mapOptions"
      (mapClick)="handleMapClick($event)">

      <map-marker
        *ngIf="selectedPosition"
        [position]="selectedPosition">
      </map-marker>

    </google-map>
  </div>
  
</div>

<!-- <div class="controls">
  <button nz-button nzType="default" (click)="onSelectLocation()"><nz-icon nzType="pushpin" nzTheme="outline" /> Set Location</button>
  <button nz-button nzType="default" (click)="onClearSelection()"><nz-icon nzType="close-circle" nzTheme="outline" /> Cancel</button>
</div>
<div *ngIf="selectedLocationDetails" class="details-container">
  <h2>Selected Position:</h2>
  <p>
    <strong>Formatted Address:</strong> 
    {{ selectedLocationDetails.formatted_address }}
  </p>
  <p>
    <strong>Latitude:</strong> 
    {{ selectedLocationDetails.geometry.location.lat() }}
  </p>
  <p>
    <strong>Longitude:</strong> 
    {{ selectedLocationDetails.geometry.location.lng() }}
  </p>

</div> -->